var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10C7.5 10.2472 7.42669 10.4889 7.28934 10.6945C7.15199 10.9 6.95676 11.0602 6.72836 11.1548C6.49995 11.2495 6.24861 11.2742 6.00614 11.226C5.76366 11.1777 5.54093 11.0587 5.36612 10.8839C5.1913 10.7091 5.07225 10.4863 5.02402 10.2439C4.97579 10.0014 5.00054 9.75005 5.09515 9.52165C5.18976 9.29324 5.34998 9.09801 5.55554 8.96066C5.7611 8.82331 6.00277 8.75 6.25 8.75C6.58152 8.75 6.89946 8.8817 7.13388 9.11612C7.3683 9.35054 7.5 9.66848 7.5 10ZM13.75 8.75C13.5028 8.75 13.2611 8.82331 13.0555 8.96066C12.85 9.09801 12.6898 9.29324 12.5952 9.52165C12.5005 9.75005 12.4758 10.0014 12.524 10.2439C12.5722 10.4863 12.6913 10.7091 12.8661 10.8839C13.0409 11.0587 13.2637 11.1777 13.5061 11.226C13.7486 11.2742 13.9999 11.2495 14.2284 11.1548C14.4568 11.0602 14.652 10.9 14.7893 10.6945C14.9267 10.4889 15 10.2472 15 10C15 9.66848 14.8683 9.35054 14.6339 9.11612C14.3995 8.8817 14.0815 8.75 13.75 8.75ZM10 8.75C9.75277 8.75 9.5111 8.82331 9.30554 8.96066C9.09998 9.09801 8.93976 9.29324 8.84515 9.52165C8.75054 9.75005 8.72579 10.0014 8.77402 10.2439C8.82225 10.4863 8.9413 10.7091 9.11612 10.8839C9.29093 11.0587 9.51366 11.1777 9.75614 11.226C9.99861 11.2742 10.2499 11.2495 10.4784 11.1548C10.7068 11.0602 10.902 10.9 11.0393 10.6945C11.1767 10.4889 11.25 10.2472 11.25 10C11.25 9.66848 11.1183 9.35054 10.8839 9.11612C10.6495 8.8817 10.3315 8.75 10 8.75Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.f292df56.svg";
export { ForwardRef as ReactComponent };